import { useCallback } from 'react';
import { setObjectKeyCloned } from 'utils/objectUtils';
import { useOrganizationSettings } from '../../settings/useOrganizationSettings/useOrganizationSettings';
import useOrganizationUpdate from '../../useOrganizationUpdate';
import { defaultOrganizationBlobSettings } from '../constants/constants';
import { IOrganizationSettings } from '../types/OrganizationSettings';

export default function useOrganizationSettingsUpdate() {
  const settings = useOrganizationSettings();
  const [updateKey] = useOrganizationUpdate();

  return useCallback(
    <K extends keyof IOrganizationSettings>(key: K, payload: IOrganizationSettings[K]) => {
      return updateKey(
        'organizationSettings',
        JSON.stringify(setObjectKeyCloned(settings ?? defaultOrganizationBlobSettings, key, payload))
      );
    },
    [settings, updateKey]
  );
}
